/**
 * @generated SignedSource<<d8b78550797c5b8542387b196eca5630>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsVelocityWallArticle$data = {
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersIsVelocityWallArticle";
};
export type helpersIsVelocityWallArticle$key = {
  readonly " $data"?: helpersIsVelocityWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsVelocityWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsVelocityWallArticle"
};

(node as any).hash = "5bf52b16f389a82e4b98aa30c1c43405";

export default node;
